module.exports = __webpack_public_path__ + "img/ext3.fdab8907.png";